<template>
	<div class="strategy">
		<div class="strategy-box" v-for="(item, index) in infos" :key="index">
			<div class="box-title">
				<div>
					<span>{{ item.name }}</span>
					<span class="unit">（元/kWh）</span>
				</div>
				<div style="display: flex; align-items: center">
					<FormOutlined
						:style="{
							color: props.disabled
								? 'rgba(0,0,0,.45)'
								: '#0058FC',
							width: '14px',
							height: '14px',
						}"
					/>
					<span
						@click="editTimeRange(item, index)"
						:class="{
							edit: true,
							disabled: props.disabled,
						}"
					>
						修改
					</span>
				</div>
			</div>
			<div class="box-bottom">
				<div class="prices">
					<div
						class="price-item"
						v-for="(price, index) in item.detail"
						:key="index + 'price'"
					>
						<div class="name">{{ price.title }}</div>
						<div class="num">{{ price.value }}</div>
					</div>
				</div>
				<div class="line"></div>
				<div class="">
					<echarts-component
						style="height: 174px"
						:options="item.option"
					></echarts-component>
				</div>
			</div>
		</div>

		<!-- 模版修改弹窗 -->
		<strategy-template-modal
			:visible="modal.visible"
			:title="modal.title"
			:defaultStrategyData="defaultStrategyData"
			:clickIndex="clickIndex"
			type="select"
			:modalData="modal.data"
			@visibleChange="visibleChange"
			@regetTable="regetTable"
			@rebackData="rebackData"
		></strategy-template-modal>
	</div>
</template>

<script setup>
import {FormOutlined} from "@ant-design/icons-vue";
import {onMounted, reactive, ref, watch, defineExpose, nextTick} from "vue";
import {toFixed, defaultOptions, setNotOpt, map} from "@/plugins/index.js";
import moment from "moment";

// components
import EchartsComponent from "@/components/EchartsComponent.vue";
import StrategyTemplateModal from "@/components/StrategyTemplateModal.vue";

const props = defineProps({
	defaultStrategyData: {
		type: Object,
		default: () => {
			return null;
		},
	},
	strategyData: {
		type: Object,
		default: () => {
			return null;
		},
	},
	disabled: {
		type: Boolean,
		default: () => {
			return false;
		},
	},
});

watch(
	() => props.strategyData,
	newVal => {
		if (newVal) {
			strategy.value = newVal;
			handleData(strategy.value);
		}
	},
	{immediate: true, deep: true}
);

// 无值时取默认值
watch(
	() => props.defaultStrategyData,
	newVal => {
		if (newVal && props.strategyData == null) {
			strategy.value = newVal;
			handleData(strategy.value);
		}
	},
	{immediate: true, deep: true}
);

// let map = {
// 	sharp: "尖",
// 	peak: "峰",
// 	flat: "平",
// 	valley: "谷",
// 	ravine: "深谷",
// };

// 存储原数据
const strategy = ref(null);
// 存储点击点index
const clickIndex = ref(null);
const infos = ref([]);

const modal = reactive({
	title: "",
	visible: false,
	data: null,
});

// 处理数据
const handleData = (data = []) => {
	let arr = [];
	data.map(row => {
		let obj = {
			name: row.name,
			months: row.months,
			detail: [
				{
					value: row.sharp,
					title: "尖",
				},
				{
					value: row.peak,
					title: "峰",
				},
				{
					value: row.flat,
					title: "平",
				},
				{
					value: row.valley,
					title: "谷",
				},
				{
					value: row.ravine,
					title: "深谷",
				},
			],
			option: {},
		};

		const Options = handleTacticsData(row);
		Options.yAxis["axisLabel"] = {
			formatter: function (value) {
				if (value === 0) {
					return "静置";
				} else if (value === 1) {
					return "充电";
				} else if (value === -1) {
					return "放电";
				} else {
					return "-";
				}
			},
		};
		delete Options.legend;
		Options.tooltip = {
			trigger: "axis",
			formatter: params => {
				let str = `-`;
				if (params.length > 0) {
					const value = params[0].data;
					const time = params[0].axisValue;

					if (value === 0) {
						str = "静置";
					} else if (value === 1) {
						str = "充电";
					} else if (value === -1) {
						str = "放电";
					} else {
						str = "-";
					}

					str = `${time} <span style="color: #0BBA74">${str}</span>`;
				}
				return `${str}`;
			},
		};
		Options.color = ["#0BBA74"];
		Options.series[0].step = "end";
		obj.option = Options;
		console.log("obj", Options);
		arr.push(obj);
	});

	infos.value = arr;
};

const yDa = ref([]);

// 处理策略数据
const handleTacticsData = res => {
	const {strategyInfo, periods} = res;

	// 将范围切割为15分钟一个点
	const curve = processTimeIntervals(strategyInfo);

	let x_data = [];
	let y_data = [];
	curve.map(el => {
		let time = el.time.split(":").splice(0, 2).join(":");
		x_data.push(time);
		y_data.push(toFixed(el.value));
	});
	let allTimes = [...x_data];
	let markAreaData = [];
	periods.map(el => {
		allTimes.push(el.start);
		allTimes.push(el.end);
		markAreaData.push([
			{
				name: map[el.type],
				xAxis: el.start,
				itemStyle: {
					color:
						el.type == "sharp"
							? "rgba(197,202,213,0.6)"
							: el.type == "peak"
							? "rgba(197,202,213,0.5)"
							: el.type == "flat"
							? "rgba(197,202,213,0.4)"
							: el.type == "valley"
							? "rgba(197,202,213,0.3)"
							: "rgba(197,202,213,0.2)",
				},
			},
			{
				xAxis: el.end,
			},
		]);
	});
	console.log("y_data:", y_data);
	let Options = {
		...JSON.parse(JSON.stringify(defaultOptions)),
		series: [
			{
				name: "电价",
				data: y_data,
				type: "line",
				symbol: "none", // 去除圆点
				markArea: {
					data: markAreaData,
				},
				// smooth: true
			},
		],
	};
	Options.grid = {
		left: "2%",
		right: "5%",
		top: "13%",
		bottom: "0%",
		containLabel: true,
	};
	Options.xAxis.data = [...new Set(allTimes)].sort();
	Options.yAxis.interval = 1; // 设置刻度线的显示间隔为 1
	//
	return Options;
};

// 切割15分钟一个点
const splitTimeRange = (startTime, endTime, interval = 15 * 60 * 1000) => {
	let result = [];

	// 将开始时间和结束时间转换为Date对象
	let startDate = new Date(startTime);
	let endDate = new Date(endTime);

	// 循环拆解时间范围
	while (startDate < endDate) {
		// 将当前时间段的开始时间和结束时间添加到结果数组中
		result.push({
			start: moment(new Date(startDate)).format("HH:mm"),
			end: moment(
				new Date(startDate.getTime() + interval) > endDate
					? endDate
					: new Date(startDate.getTime() + interval)
			).format("HH:mm"),
		});

		// 增加间隔时间
		startDate.setTime(startDate.getTime() + interval);
	}

	return result;
};

// 汇总处理切割的数据
const processTimeIntervals = data => {
	const result = data.map(interval =>
		splitTimeRange(
			`2024/01/01 ${interval.start}`,
			`2024/01/01 ${interval.end}`
		).map(timeInterval => ({
			time: timeInterval.start,
			value: interval.type,
		}))
	);

	// 数组扁平化
	const flattenedResult = result.flat(Infinity);

	return flattenedResult;
};

// 修改
const editTimeRange = (row, index) => {
	if (!props.disabled) {
		modal.title = row.name;
		modal.visible = true;
		modal.data = strategy.value[index];
		console.log(strategy.value[index]);
		clickIndex.value = index;
	}
};

// 弹窗
const visibleChange = emit => {
	modal.visible = emit || false;
};

// 新建成功
const regetTable = () => {
	pagination.current = 1;
	pagination.pageSize = 10;

	getTableList();

	modal.visible = false;
};

// 返回数据
const rebackData = emit => {
	console.log("emit:", emit);
	strategy.value[clickIndex.value] = {
		...strategy.value[clickIndex.value],
		...emit,
	};
	modal.visible = false;
};

const getPriceStrategy = () => {
	return strategy.value;
};

defineExpose({
	getPriceStrategy,
});
</script>

<style lang="less" scoped>
.strategy {
	&-box {
		margin-bottom: 16px;
		.box-title {
			font-family: PingFangSC-Medium;
			font-weight: 500;
			font-size: 16px;
			color: rgba(0, 0, 0, 0.85);
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 8px;
			.unit {
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: rgba(0, 0, 0, 0.65);
			}
			.icon {
				display: inline-block;
				width: 14px;
				height: 14px;
				background-color: #0058fc;
				font-size: 14px;
			}
			.edit {
				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 14px;
				color: #0058fc;
				margin-left: 4px;
				&:hover {
					cursor: pointer;
				}
			}
			.disabled {
				color: rgba(0, 0, 0, 0.45);
				&:hover {
					cursor: not-allowed;
				}
			}
		}
		.box-bottom {
			background: #e9eff633;
			border: 1px solid #a2abbb66;
			border-radius: 4px;
			padding: 12px;
			.line {
				width: 100%;
				border-bottom: 1px solid #a2abbb66;
				margin: 16px 0;
			}
		}
		.prices {
			position: relative;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			grid-column-gap: 16px;
			grid-row-gap: 8px;
			.price-item {
				.name {
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 12px;
					color: #000000;
					opacity: 0.65;
				}
				.num {
					opacity: 0.85;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
				}
			}
		}
	}
}
</style>
